/**
 * Updates the Shopify header login/account link after multipass login
 * This is called after multipass login to update the header to show logged-in state
 * (e.g., "Iniciar sesión" → "Mi cuenta")
 *
 * Uses a surgical approach to only update the account link, not the entire header
 */
export async function updateShopifyHeader(): Promise<void> {
  try {
    // Find the account/login link in the current page header
    // Use attribute selectors that match both root paths and locale-prefixed paths (e.g., /en/account)
    const accountLink = document.querySelector(
      'a[href="/account/login"], a[href="/account"], ' +
      'a[href$="/account/login"], a[href$="/account"]:not([href*="/account/"])'
    );

    if (!accountLink) {
      return;
    }

    // Fetch the full current page to get updated header HTML
    const response = await fetch(window.location.pathname);

    if (!response.ok) {
      return;
    }

    const html = await response.text();

    // Create a temporary container to parse the HTML
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = html;

    // Find the account link in the fetched HTML (logged-in version)
    // Match both /account and locale-prefixed versions like /en/account
    const newAccountLink = tempContainer.querySelector(
      'a[href="/account"], a[href$="/account"]:not([href*="/account/"])'
    );

    if (!newAccountLink) {
      return;
    }

    // Replace the old link with the new one
    accountLink.replaceWith(newAccountLink.cloneNode(true));
  } catch {
    // Silently fail - this is a nice-to-have enhancement
  }
}
